import debug from 'debug';

export default (name = 'auditz') => debug(`loopback:mixins:${name}`);
